/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';

class PriceItPlusBrand extends Component {
  render() {
    const { data: { brands, enrollment_status } } = this.props;

    return (
      <div className="performance-details" style={{ paddingTop: 0 }}>
        <div>
          <Grid bsClass="container" fluid>
            {brands.map((brand, index) => (
              <div key={index}>
                <h2 className="no-padding">
                  {brand.name}
                  &nbsp;
                  {enrollment_status === 'Enrolled' && (<span><strong>{brand.points || 0}</strong> ignite points per product</span>) }
                </h2>
                <div className="performance-details-container">
                  <span className="text-bold product-margin-right">
                    Product
                  </span>
                  <div>
                    <div className="performance-details-row-images">
                      {brand.product_images.map((productImage, productImageIndex) => (
                        <div
                          key={productImageIndex}
                          className="performance-details-row-images-container"
                        >
                          <img src={productImage} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {brand.shelf_price && (
                  <div className="brand-margin-top">
                    <span className="text-bold brand-margin-right">
                      Shelf price
                    </span>
                    {brand.shelf_price || 0}
                  </div>
                )}
              </div>
            ))}
          </Grid>
        </div>
      </div>
    );
  }
}

export default PriceItPlusBrand;



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances/subcomponents/price-it-plus-brand.jsx